
import { RsProjectGlobalSensor } from "@/commons/interface/project-device/project-sensor"
import { StdResponse, bimAxios } from "@/config/axios"

export function getProjectSensors(projectUuid: string, type: number, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/projects/${projectUuid}/project-global-sensors`, {
        params: {
            ...params,
            type: type,
        }
    })
}

export function createProjectGSensors(data: RsProjectGlobalSensor[], params?: {}): Promise<StdResponse<any>> {
    return bimAxios.post(`/project-global-sensors`, data, {
        params: {
            ...params,
        }
    })
}

export function deleteProjectGSensor(projectUuid: string, globalSensorId: number, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.delete(`/project-global-sensors/delete`, {
        params: {
            ...params,
            projectUuid: projectUuid,
            globalSensorId: globalSensorId,
        }
    })
}   